import * as React from 'react';
import { Button } from '../../../../../designSystem/button/Button';
import { AnimatedCollapsibleContent } from '../../../../../designSystem/collapsible/AnimatedCollapsibleContent';
import { colors } from '../../../../../designSystem/colors/color';
import { Flex, FlexItem } from '../../../../../designSystem/compositeComponents/FlexHelpers';
import { ListRow } from '../../../../../designSystem/compositeComponents/ListRow';
import { Label } from '../../../../../designSystem/Label';
import { ReleaseRecordEmail } from '../../../../../amorg-common';

export type ArticleViewReleaseEmailsProps = {
    emails: ReleaseRecordEmail[];
};

export function ArticleViewReleaseEmails (props: ArticleViewReleaseEmailsProps): JSX.Element
{
    const [open, setOpen] = React.useState<boolean>(false);

    return (
        <ListRow styleVariant='neutral' level='level2' stripColor={props.emails.length === 0 ? colors.icon.passive : colors.icon.active}>
            <Flex alignItems='center'>
                <FlexItem flexGrow='1'>
                    {props.emails.length === 0
                        ? <i>Ingen emails sendt ved udgivelse</i>
                        : <Label>{props.emails.length} email(s)</Label>}
                </FlexItem>

                {props.emails.length > 0 &&
                    <Button variant='text' icon={open ? 'caret_caretUp' : 'caret_caretDown'} onClick={() => setOpen(!open)} />}
            </Flex>

            <AnimatedCollapsibleContent open={open}>
                {props.emails.map((email) => <div key={email.userId}>
                    {email.email}
                    &nbsp;(<i>
                        {email.status === 'success' && <>Sendt</>}
                        {email.status === 'pending' && <>Ikke sendt</>}
                        {email.status === 'failure' && <>Fejl</>}
                        {email.status === 'success-skipped' && <>(ikke sendt - stille udgivelse)</>}
                        {email.status !== 'success' && email.status !== 'pending' && email.status !== 'failure' &&
                            <>Ukendt</>}
                    </i>)
                </div>
                )}
            </AnimatedCollapsibleContent>
        </ListRow>
    );
}
